import { Trans } from "@lingui/macro";
import { UiModule } from "@smp/ui";
import { FC, useCallback } from "react";

import { useWindowTitle } from "@/hooks/use_window_title";

import { TemplateDialog, UnsplashDialog } from "./components";
import { ProviderPolotnoTemplates } from "./context";
import { IPolotnoTemplatesProps } from "./polotno_templates.types";
import { Filters, Viewport } from "./screens";

export const PolotnoTemplates: FC<IPolotnoTemplatesProps> = ({
  pathPattern,
  isRoutingDisabled,
  isWidget,
  onToggleSidebar,
  isSidebarCollapsed,
  isDialogPortalEnable,
  ...props
}) => {
  useWindowTitle("/templates");

  const handleCollapseSidebar = useCallback(() => {
    if (onToggleSidebar) {
      onToggleSidebar(false);
    }
  }, [onToggleSidebar]);

  const handleExpandSidebar = useCallback(() => {
    if (onToggleSidebar) {
      onToggleSidebar(true);
    }
  }, [onToggleSidebar]);

  return (
    <ProviderPolotnoTemplates
      isRoutingDisabled={isRoutingDisabled}
      isWidget={isWidget}
      pathPattern={pathPattern}
      {...props}
    >
      <UiModule
        forceMainOnly={isWidget}
        forceSecondaryDrawer={!isWidget}
        isSidebarForceOpen={!isWidget && !isSidebarCollapsed}
        ScreenMain={
          <>
            <Viewport />
            <TemplateDialog enablePortal={isDialogPortalEnable} />
            <UnsplashDialog enablePortal={isDialogPortalEnable} />
          </>
        }
        ScreenSecondary={<Filters />}
        ScreenSecondaryDrawerLabel={
          <Trans>templates.filters.Show filters</Trans>
        }
        isSidebarVisible
        disableSecondaryAwayClick={true}
        onCollapseSidebar={handleCollapseSidebar}
        onExpandSidebar={handleExpandSidebar}
      />
    </ProviderPolotnoTemplates>
  );
};
